import PGSHelper from "../helpers/PGSHelper.js";
import Currencies from "./Currencies.js";
import moment from "moment"
export default class ActivityReservation {
  constructor(data) {
    this.id = data?.id ? data.id : null;
    this.ia = data?.ia ? data.ia : null;
    this.ac = data?.ac ? data.ac : {id:null,nm:null};
    this.fl = data?.fl ? data.fl : "";
    this.fi = data?.fi ? data.fi : "";
    this.fv = data?.fv ? data.fv : "";
    this.dc = data?.dc ? data.dc : "";
    this.ft = data?.ft ? data.ft : "";
    this.bh = data?.bh ? data.bh : {id:null,nm:null};
    this.et = data?.bh ? data.et : "R";
    this.cl = data?.cl
      ? data.cl
      : {
          id: "",
          nm: "",
          al: "",
          gp: "",
        };
    this.ct = data?.ct ? data.ct : [];
    this.nt = data?.ct ? data.nt : "";
    this.ts = data?.ts ? data.ts : [];
    this.pv = data?.pv ? data.pv : [];
    this.tt = data?.tt ? data.tt : { C: 0, M: Currencies.getCurrencyDefault() };
    this.Categoria = null;
    this.Pco = { C: 0, M: Currencies.getCurrencyDefault() };
    this.dataClient = "";
    this.Nombre = "";
    this.isClient = false;
  }
  static parseAvailability(datos) {
    let arrayRes = [];
    let bahias = Object.entries(datos);
    bahias.forEach((bahia) => {
      let horarios = Object.entries(bahia[1]);
      horarios.forEach((horario) => {
        let reservas = Object.entries(horario[1]);
        reservas.forEach((res) => {
          arrayRes.push({
            HoraInicial:horario[0],
            HoraFinal:new moment(res[1].ft,"YYYY-MM-DD_HH:mm").format("HH:mm"),
            bahia:bahia[0],
            idReserva: res[0],
            ...res[1],
          });
        });
      });
    });
    return arrayRes;
  }
  setStatus(Estatus){
    if(this.et != "P"){
      this.et = Estatus
    }
    
  }
  getHoraInicial(){
    let hora = moment(this.fi,"YYYY-MM-DD_HH:mm:ss").format("HH:mm")
    return hora
  }
  getFechaInicial(){
    let fecha = moment(this.fi,"YYYY-MM-DD_HH:mm:ss").format("YYYY-MM-DD")
    return fecha
  }
  toDataForm(){
    let helper = new PGSHelper();
    
    this.Pco = { C: 0, M: Currencies.getCurrencyDefault() };
    this.dataClient = "";
    this.Nombre = this.cl.al;
    let existBaseProd = helper.getById(this.ct, "Tip", "ACT-Reserva");
    if(existBaseProd){
      this.Pco = existBaseProd.Pco
      this.Categoria = existBaseProd.Categoria.I;
    }
    if(this.cl.id == "PUBLICOGENERAL"){
      this.isClient = false;
      this.dataClient = this.cl.al
    }else{
      this.isClient = true;
    }
    
  }
  toDataDoc(data) {
    this.Pco.C = Number(this.Pco.C)
    let helper = new PGSHelper();
    this.nt = data.nt;
    this.fi = data.fi;
    this.ft = data.ft;
    this.bh = data.bh;
    this.dc = data.dc;
    this.ac = data.ac;
    this.pv = false;
    if (this.isClient) {
      this.cl = {
        id: this.dataClient.Id,
        nm: this.dataClient.Nombres + " " + this.dataClient.Apellidos,
        al: this.dataClient.Nombres + " " + this.dataClient.Apellidos,
        gp: "",
      };
    } else {
      this.cl = {
        id: "PUBLICOGENERAL",
        nm: "PUBLICO GENERAL",
        al: this.Nombre,
        gp: "",
      };
    }
    let existBaseProd = helper.getById(this.ct, "Tip", "ACT-Reserva");
    if (existBaseProd) {
      this.ct[existBaseProd.idx].Nombre = data.dsc;
      this.ct[existBaseProd.idx].Categoria = {
        I: data.CategoriaData.id,
        N: data.CategoriaData.cnm,
      };
      this.ct[existBaseProd.idx].Familia = {
        I: data.CategoriaData.fmi,
        N: data.CategoriaData.fmn,
      };
      this.ct[existBaseProd.idx].Pco = this.Pco;
      this.ct[existBaseProd.idx].Mnd = this.Pco.M;
      this.ct[existBaseProd.idx].ExtraParams = data.ExtraParams;
      this.ct[existBaseProd.idx].Notas = data.nt;
    } else {
      this.Pco.C = Number(this.Pco.C);
      let prod = {
        Id: "ACTRESERVA",
        Nombre: data.dsc,
        Iva: 0,
        Categoria: { I: data.CategoriaData.id, N: data.CategoriaData.cnm },
        Familia: { I: data.CategoriaData.fmi, N: data.CategoriaData.fmn },
        Tip: "ACT-Reserva",
        Pco: this.Pco,
        Mnd: this.Pco.M,
        Cnt: 1,
        Cto: null,
        Descuentos: [],
        Pcs: {C:0,P:0},
        Catalogo: [],
        ExtraParams: data.ExtraParams,
        Notas: data.nt,
      };
      this.ct.push(prod);
    }
    this.tt.C = 0
    this.ct.forEach((prod) => {
      if (prod.Pco.M == Currencies.getCurrencyDefault()) {
        
        this.tt.C += Number(prod.Pco.C);
      } else {
        this.tt.C += Number(
          Currencies.getExchangeRateByCurrency(
            prod.Pco.C,
            prod.Pco.M,
            Currencies.getCurrencyDefault()
          )
        );
      }
      
    });
    
  }
}
